import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

interface ContentTemplateError {
  title: string;
  descrition: string;
  img: string;
}

/*
 * @example

 * <app-template-error 
 *  *ngIf="errorPost"
 *  [type]="'generic'"
 *  [loadingButton]="loadingButton"
 *  [focusBtnHeader]="focusBtnHeaderError"
 *  (tryAgainBtnClick)="sendUserData()"
 *  (closeBtnClick)="closeBtnClickError()"
 * >
 * </app-template-error>

*/

@Component({
  selector: 'app-template-error',
  templateUrl: './template-error.component.html',
  styleUrls: ['./template-error.component.scss'],
})
export class TemplateErrorComponent implements OnChanges {

  @Input()  type: 'generic' | 'offline' = 'generic';
  @Input()  loadingButton: boolean;
  @Input()  focusBtnHeader = false;
  @Input()  showBtnTryAgain = true;
  @Output() tryAgainBtnClick = new EventEmitter();
  @Output() closeBtnClick = new EventEmitter();
  
  @ViewChild('btnHeader', {static: false}) btnHeader: ElementRef;

  contentType = {
    generic: {
      title: 'Desculpe, estamos passando por instabilidade',
      descrition: 'Por favor, tente novamente em alguns minutos.',
      img: '../../../assets/images/svg/error-generic.svg'
    },
    offline: {
      title: 'Parece que perdemos a conexão com a internet',
      descrition: 'Vamos tentar novamente?',
      img: '../../../assets/images/svg/error-offline.svg'
    }
  }
  labelBtnHeader = 'fechar';
  content: ContentTemplateError;
  counterTryAgain = 0;
  alertVoiceOver = false;

  constructor() {
    this.setContentTemplate();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.focusBtnHeader.currentValue) {
      this.focusCloseBtn();
      this.updateHideBtnTryAgain();
    }
    
  }

  setContentTemplate () {
    this.content = this.contentType[this.type];
  }

  updateHideBtnTryAgain () {
    if (this.counterTryAgain === 3) {
      this.showBtnTryAgain = false;
    }
  }

  focusCloseBtn () {
    setTimeout(() => {
      this.btnHeader.nativeElement.focus();
    }, 20);
  }

  onTryAgain() {
    this.counterTryAgain = this.counterTryAgain + 1;
    this.tryAgainBtnClick.emit();
  }

  onCloseBtnClick() {
    this.closeBtnClick.emit();
  }

  showAlertVoiceOver () {
    this.alertVoiceOver = true;
    setTimeout(() => this.alertVoiceOver = false, 1000);
  }

}


